import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import valoresNormalesApi from "../../api/masters/valoresNormalesApi";
import { apiGetConsecutivos } from "../../api/consecutivoApi";
import { apiGetSubGrupos } from "../../api/subGruposApi";

const emptyForm = {
  id: "",
  Consecutivo: "",
  Tipo: "N",
  Largo: "",
  Normal_min: "",
  Normal_max: "",
  ValorReferencia: "",
  Accion: "",
  Subgrupo: "",
  AutoSubgrupo: "",
  Orden: "",
  Valor_Minimo: "",
  Valor_maximo: "",
  edad_inicial: 0,
  edad_final: 120,
  sexo: "A",
};

export const useValoresNormales = () => {
  const [valores, setValores] = useState([]);
  const [consecutivos, setConsecutivos] = useState([]);
  const [subgrupos, setSubgrupos] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadConsecutivos = async () => {
    try {
      const res = await apiGetConsecutivos();
      if (res?.data) {
        setConsecutivos(res.data);
      }
    } catch {
      // Ignorar fallo no crítico
    }
  };

  const loadSubgrupos = async () => {
    try {
      const res = await apiGetSubGrupos("", "");
      if (res?.data) {
        setSubgrupos(res.data);
      }
    } catch {
      // Ignorar fallo no crítico
    }
  };

  const loadValores = async () => {
    setLoading(true);
    try {
      const res = await valoresNormalesApi.getAll();
      setValores(res?.data || []);
    } catch {
      toast.error("Error al cargar los valores normales");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadConsecutivos();
    loadSubgrupos();
    loadValores();
  }, []);

  const handleSelect = async (id) => {
    setSelectedId(id);
    try {
      const res = await valoresNormalesApi.getById(id);
      if (res?.success && res.data) {
        const item = res.data;
        setForm({
          id: item.id,
          Consecutivo: item.Consecutivo ?? "",
          Tipo: item.Tipo ?? "N",
          Largo: item.Largo ?? "",
          Normal_min: item.Normal_min ?? "",
          Normal_max: item.Normal_max ?? "",
          ValorReferencia: item.ValorReferencia ?? "",
          Accion: item.Accion ?? "",
          Subgrupo: item.Subgrupo ? String(item.Subgrupo) : "",
          AutoSubgrupo: item.AutoSubgrupo ? String(item.AutoSubgrupo) : "",
          Orden: item.Orden ?? "",
          Valor_Minimo: item.Valor_Minimo ?? "",
          Valor_maximo: item.Valor_maximo ?? "",
          edad_inicial: item.edad_inicial ?? 0,
          edad_final: item.edad_final ?? 120,
          sexo: item.sexo ?? "A",
        });
      } else {
        toast.error("No se pudo cargar la información seleccionada");
      }
    } catch {
      toast.error("Error al consultar el registro");
    }
  };

  const handleNew = () => {
    setSelectedId(null);
    setForm(emptyForm);
  };

  const handleSave = async () => {
    if (!form.Consecutivo) {
      toast.warning("Debe seleccionar un Consecutivo");
      return;
    }
    if (!form.Tipo) {
      toast.warning("Debe seleccionar un Tipo de dato");
      return;
    }

    setSaving(true);
    try {
      const res = await valoresNormalesApi.save(form);
      if (res?.success) {
        toast.success(form.id ? "Valor normal actualizado" : "Valor normal creado exitosamente");
        await loadValores();
        if (!form.id && res.data?.lastId) {
          handleSelect(res.data.lastId);
        } else if (form.id) {
          handleSelect(form.id);
        }
      } else {
        toast.error(res?.message || "Error al guardar el valor normal");
      }
    } catch {
      toast.error("Error interno al guardar");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!id) return;
    try {
      const res = await valoresNormalesApi.delete(id);
      if (res?.success) {
        toast.success("Valor normal eliminado");
        if (selectedId === id) {
          handleNew();
        }
        await loadValores();
      } else {
        toast.error(res?.message || "Error al eliminar");
      }
    } catch {
      toast.error("Error al procesar la eliminación");
    }
  };

  const filteredValores = valores.filter((v) => {
    const q = search.toLowerCase();
    const consMatch = String(v.Consecutivo || "").includes(q);
    const apiMatch = (v.ConsecutivoNombre || "").toLowerCase().includes(q);
    const refMatch = (v.ValorReferencia || "").toLowerCase().includes(q);
    return consMatch || apiMatch || refMatch;
  });

  return {
    valores: filteredValores,
    allValores: valores,
    consecutivos,
    subgrupos,
    selectedId,
    form,
    setForm,
    search,
    setSearch,
    loading,
    saving,
    handleSelect,
    handleNew,
    handleSave,
    handleDelete,
  };
};

export default useValoresNormales;

